var React = require('react');

function Vimeo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M230.7,46.3c-1,22.5-16.7,53.3-47.1,92.4C152.2,179.6,125.7,200,104,200c-13.4,0-24.8-12.4-34.1-37.3\r\n\tc-6.2-22.8-12.4-45.6-18.6-68.4C44.3,69.4,36.9,56.9,29,56.9c-1.7,0-7.8,3.6-18.1,10.9L0,53.8c11.4-10,22.6-20.1,33.7-30.1\r\n\tC48.9,10.6,60.3,3.6,67.9,2.9c18-1.7,29,10.6,33.2,36.9c4.5,28.4,7.6,46.1,9.3,53c5.2,23.6,10.9,35.3,17.1,35.3\r\n\tc4.8,0,12.1-7.6,21.8-22.9c9.7-15.3,14.8-26.9,15.5-34.9c1.4-13.2-3.8-19.8-15.5-19.8c-5.5,0-11.2,1.3-17.1,3.8\r\n\tc11.3-37.2,33-55.3,65-54.3C220.8,0.7,232,16.1,230.7,46.3z"}));
}

Vimeo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"230.8px","height":"200px","viewBox":"0 0 230.8 200","style":{"enableBackground":"new 0 0 230.8 200"},"xmlSpace":"preserve"};

module.exports = Vimeo;

Vimeo.default = Vimeo;
